import { render, staticRenderFns } from "./MedicoObs.vue?vue&type=template&id=31071d28&"
import script from "./MedicoObs.vue?vue&type=script&lang=js&"
export * from "./MedicoObs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports